export const ArrowHeaderDown = () => {
  return (
    <svg
      className="block dropdown-link-arrow"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00002 9.83331C7.87202 9.83331 7.744 9.78466 7.64666 9.68666L4.98 7.01999C4.78466 6.82466 4.78466 6.50797 4.98 6.31264C5.17533 6.1173 5.49202 6.1173 5.68735 6.31264L8.00067 8.62595L10.314 6.31264C10.5093 6.1173 10.826 6.1173 11.0213 6.31264C11.2167 6.50797 11.2167 6.82466 11.0213 7.01999L8.35467 9.68666C8.256 9.78466 8.12802 9.83331 8.00002 9.83331Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
